// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class MaterialTypeAgg {
  readonly materialType: Enums.MaterialType;
  readonly count: number;

  constructor(data: { [key: string]: any } = {}) {
    this.materialType =
      data.materialType === undefined ? Enums.MaterialType.Other : data.materialType;
    this.count = data.count === undefined ? 0 : data.count;
  }

  static zero(): MaterialTypeAgg {
    const zeroValues: ExcludeMethodsDeep<MaterialTypeAgg> = {
      materialType: Enums.MaterialType.Other,
      count: 0,
    };
    return new MaterialTypeAgg(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type MaterialTypeAggWireFormat = {
  materialType: string;
  count: number;
};

type NewMaterialTypeAggProps = PartialDeep<MaterialTypeAgg, { recurseIntoArrays: true }>;
export const NewMaterialTypeAgg: (props: NewMaterialTypeAggProps) => MaterialTypeAgg = (props) =>
  new MaterialTypeAgg(props);

type NewMaterialTypeAggFromWireFormatProps = PartialDeep<
  MaterialTypeAggWireFormat,
  { recurseIntoArrays: true }
>;
export const NewMaterialTypeAggFromWireFormat: (
  props: NewMaterialTypeAggFromWireFormatProps,
) => MaterialTypeAgg = (props) => new MaterialTypeAgg(props);
